import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
@Injectable()
export class TemDefterTurService {
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}

  setParams(isReadOnly:boolean, isBindCheck:boolean){
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }
  getData(code: number,control:any, baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
    }
    dataSource.select(['Kod', 'Ad', 'Turu']);
    const filterArr = [];
    if(code)filterArr.push(['Kod', '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
